export default __webpack_public_path__ + "images/WinterHelpBackground.web.png";